

export function getLevel(role) {
    return {
        lgu: "lgu",
        province: "province",
        admin: "region",
        reviewer: "region"
    }[role];
}

const ROLE_TITLES = {
    // guest: "Guest",
    admin: "Administrator",
    reviewer: "Reviewer",
    lgu: "T.O.",
    province: "P.T.O",
};


export function getRoleLabel(role, roleSpecific, collection) {
    let title = ROLE_TITLES[role] || "Unknown";
    let specific = null;

    if(role === "lgu") {
        const lgu = collection.lgu[roleSpecific]; 
        const province = collection.province[lgu.province];

        title = "T.O.";
        specific = `${lgu.name}, ${province.name}`;
    }
    
    if(role === "province") specific = collection.province[roleSpecific]?.name;

    return { title, specific };
}

export function listRoleOptions(filtered = false) {
    const options = [];

    for(const key in ROLE_TITLES) {
        if(filtered && [ "admin", "reviewer" ].includes(key)) continue;

        options.push({ value: key, label: ROLE_TITLES[key] });    
    }

    return options;
}

export function validateAccount(account, newAccount = true) {
    const error = error => ({ ok: false, error });
    
    if(!account.fullname.trim()) return error("Fullname is required");
    if(!account.username.trim()) return error("Username is required");
    if(newAccount && !account.password.trim()) return error("Password is required");

    if(account.password.trim() && account.password !== account.confirmPassword) 
        return error("Password must match Confirmation Password")

    delete account.confirmPassword;

    return { ok: true, account };
}